/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useContext, useEffect, useState } from "react";
import FilieraContext from "../../contexts/filieraContext";
import { useMsal } from "@azure/msal-react";
import { PermissionsApi } from "../../data/apis/PermissionsApi";
import { apiConfiguration } from "../../apiConfig";
import { LoadPanel } from "devextreme-react/load-panel";

export default function MediePage() {
  const { currentFiliera } = useContext(FilieraContext);
  const [link, setLink] = useState<string>("");
  const [loading, setLoading] = useState(true);

  const { accounts } = useMsal();
  const account = accounts[0];

  useEffect(() => {
    const load = async () => {
      if (!currentFiliera || !account) {
        setLoading(false);
        return;
      }

      try {
        const api = new PermissionsApi(apiConfiguration);

        // 1. Recupero TUTTE le filiera-permission
        const perms = await api.getFilierePermissions();

        // 2. Filtra solo permessi 'Medie'
        const mediePerms = perms.filter(p =>
          p.filieraPermissionId?.includes("Filiera/BI/Medie")
        );

        // 3. Determina suffisso filiera → /01 /02, filiera 3 → nessun link
        let suffix = "";
        switch (currentFiliera.Id) {
          case 1:
            suffix = "/01";
            break;
          case 2:
            suffix = "/02";
            break;
          default:
            // Filiera 3 o altro → nessun accesso
            setLink("");
            setLoading(false);
            return;
        }

        // 4. Trova permesso corrispondente alla filiera
        const perm = mediePerms.find(p =>
          p.filieraPermissionId?.endsWith(suffix)
        );

        if (!perm) {
          setLink("");
          setLoading(false);
          return;
        }

        // 5. Determina ruolo (solo due categorie: admin / others)
        const isGetione = perm.filieraPermissionId?.includes("/Gestione/");

        // 6. SWITCH sui link PowerBI
        let selectedLink = "";

        switch (currentFiliera.Id) {
          case 1: // Agricola
            selectedLink = isGetione
              ? "https://app.powerbi.com/reportEmbed?reportId=0fd62d51-da98-445b-8d6c-8c3988022c7c&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSectionff81ba787968891e0059"
              : "https://app.powerbi.com/reportEmbed?reportId=4fd6df77-1631-4d56-af27-5060c85cc561&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSectionff81ba787968891e0059";
            break;

          case 2: // Cascina
            selectedLink = isGetione
              ? "https://app.powerbi.com/reportEmbed?reportId=0fd62d51-da98-445b-8d6c-8c3988022c7c&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSection618b31abeb10699f0bba"
              : "https://app.powerbi.com/reportEmbed?reportId=4fd6df77-1631-4d56-af27-5060c85cc561&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSection618b31abeb10699f0bba";
            break;

          default:
            selectedLink = "";
        }

        setLink(selectedLink);
      } catch (err) {
        console.error("Errore Medie:", err);
        setLink("");
      }

      setLoading(false);
    };

    load();
  }, [currentFiliera]);

  if (loading) {
    return <LoadPanel visible={true} position={{ of: ".content" }} />;
  }

  return (
    <React.Fragment>
      {link !== "" && (
        <iframe
          src={link}
          style={{
            display: "block",
            background: "#000",
            border: "none",
            height: "85vh",
            width: "100%",
          }}
          allowFullScreen
        ></iframe>
      )}

      {link === "" && <label>Nessun report disponibile per questa filiera</label>}
    </React.Fragment>
  );
}
